import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { applyMiddleware, createStore, Store } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'

import { createRootReducer } from './reducers'

import { gaPageView } from '@globaleris/ui.library'
import { throttle } from '../helpers/throttle'
import { loadState, localStorageModel, saveState } from './localStorage'
import {
  initialAppConfigurationState,
  initialClientsStoreState,
  initialConfirmationDialogStoreState,
  initialLayoutStoreState,
  initialLeadsStoreState,
  initialNotificationsStoreState,
  initialPagesState,
  initialPricingStoreState,
  initialProfileStoreState,
  initialTasksStoreState,
  initialTradesStoreState,
  RootStoreModel
} from './store.model'

const persistedState: localStorageModel | undefined = loadState()
type AppStore = Store<RootStoreModel>

//const baseUrl: any = document.getElementsByTagName('base')[0].getAttribute('href');
const baseUrl: any = process.env.PUBLIC_URL

export const browserHistory = createBrowserHistory({ basename: baseUrl })
browserHistory.listen(location => {
  gaPageView(location.pathname)
})

const middlewares = [thunkMiddleware, routerMiddleware(browserHistory)]

export const store: AppStore = createStore(
  createRootReducer(browserHistory),
  {
    profile: {
      ...initialProfileStoreState,
      activeCompany: persistedState?.activeCompany,
      activeBalanceZone: persistedState?.activeBalanceZone
    },
    notifications: initialNotificationsStoreState,
    layout: {
      ...initialLayoutStoreState,
      newReleaseNotification: persistedState?.showReleaseNotification ?? null
    },
    confirmationDialog: initialConfirmationDialogStoreState,
    appConfiguration: initialAppConfigurationState,
    pagesState: initialPagesState,
    pricingState: initialPricingStoreState,
    tradesState: initialTradesStoreState,
    clientsState: {
      ...initialClientsStoreState,
      showCommunicationAdd: persistedState?.showCommunicationAdd ?? true,
      showCommunicationFile: persistedState?.showCommunicationFile ?? true
    },
    tasksState: {
      ...initialTasksStoreState
    },
    leadsState: {
      ...initialLeadsStoreState
    }
  },
  composeWithDevTools(applyMiddleware(...middlewares))
)

store.subscribe(
  throttle(() => {
    saveState({
      activeCompany: store.getState().profile.activeCompany,
      activeBalanceZone: store.getState().profile.activeBalanceZone,
      showCommunicationFile: store.getState().clientsState.showCommunicationFile,
      showCommunicationAdd: store.getState().clientsState.showCommunicationAdd,
      showReleaseNotification: store.getState().layout.newReleaseNotification ?? null
    })
  }, 1000)
)
